import { api } from '../../../plugins/axios';
import { Alert } from '../../../plugins/alert';
export class User {
	id = undefined;
	full_name = undefined;
	email = undefined;
	email_verified_at = undefined;
	active = undefined;
	is_owner = undefined;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	get isVerified() {
		return !!this.email_verified_at;
	}

	static async getUsers(params = {}) {
		const res = await api.get('/users', {
			params,
		});
		const data = res.data.result.users;

		return {
			data: data.data.map((item) => new User(item)),
			totalRecords: data.total,
		};
	}

	static async createUser(data) {
		try {
			await api.post('/users', data);
		} catch (err) {
			const msg = err?.response?.data?.message;
			Alert.error(msg || t('Error Msg'));
			console.error(err);
			throw err;
		}
	}

	async remove() {
		return await api.delete(`/users/${this.id}`);
	}

	async toggleStatus() {
		try {
			await api.post(`/users/toggleStatus/${this.id}`);
			this.active = this.active == 1 ? 0 : 1;
		} catch (err) {
			const msg = err?.response?.data?.message;
			Alert.error(msg || t('Error Msg'));
			console.error(err);
			throw err;
		}
	}
}
